<script setup>
import MatchGroupHeader from '@/components/Match/MatchGroupHeader.vue';
import MatchListItem from '@/components/Match/MatchListItem.vue';
import mainMarkets from '@/mainMarkets'
import { getDayNumber, getDayShortName, safeTranslate } from '@/helpers';
import { useFixturesStore } from '@/stores/fixtures';
import { storeToRefs } from 'pinia';
import { onMounted, ref, watch, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useVisibleItems } from '@/composables/useVisibleItems';

const { t, te } = useI18n()
const fixtures = useFixturesStore()
const { getPreSports: sports , getAvailablePreDates , getGroupedPreEventsByDate} = storeToRefs(fixtures)

const sport = ref()
const date = ref()
const preSelectionsMap = ref({})

const loadVisible = async (ids) => {
  if (!ids.length) return
  const preMarketId = mainMarkets[sport.value]?.[0]
  const markets = preMarketId ? [preMarketId] : undefined

  const res = await fixtures.fetchSelections(ids, "pre", markets)
  for (const ev of res) {
    preSelectionsMap.value[ev.fi] = ev.m || []
  }
}

const { observe, reset } = useVisibleItems(loadVisible, { selector: '.pre-event-item' })

const setDate = (d) => {
  date.value = d
}

watch(sport, (value) => {
  fixtures.groupPreEventsByDate(value)
  date.value = getAvailablePreDates.value[0]
})

onMounted(() => {
  sport.value = sports.value[0]?.si
})

watch(date, () => {
  reset()
  observe()
})
watch(sport, () => {
  reset()
  observe()
})
const competitionName = computed(() => (competition) => {
  return te(`competitions.${competition.i}`)
    ? t(`competitions.${competition.i}`)
    : competition.cn
})
const regionTranslation = (event) => { 
  return safeTranslate('regions', event.ri, t, te , event.rn)
}
</script>
<template>
  <div>
    <div>
      <select
        class="appearance-none bg-transparent text-[13px] text-neutral-300 border-0 focus:ring-0"
        v-model="sport"
      >
        <option
          v-for="sport in sports"
          :value="sport.si"
        >
          {{ $te(`sports.${sport.si}`) ? $t(`sports.${sport.si}`) : sport.sn }}
        </option>
      </select>
    </div>
    <div class="px-2 py-1.5">
      <ul class="list-none flex space-x-1 overflow-x-auto">
        <li v-for="d in getAvailablePreDates">
          <button
            class="w-14 text-center py-1 rounded-sm"
            :class="[d == date ? 'bg-[var(--color-primary3)]' : 'bg-neutral-500']"
            @click="setDate(d)"
          >
            <p class="text-black text-sm font-bold">{{ getDayShortName(d) }}</p>
            <p class="text-xs">{{ getDayNumber(d) }}</p>
          </button>
        </li>
      </ul>
    </div>
    <div v-for="competition in getGroupedPreEventsByDate(date)">
      <div v-lazy>
        <MatchGroupHeader :sport="sport">
          <template #title>
            <div class="flex items-center">
              <img :src="`/loc/${competition.events[0].ri}.svg`" class="w-4 h-4 rounded-full mr-2" alt="">
              {{regionTranslation(competition.events[0]) }} - {{ competitionName(competition) }}
            </div>
          </template>
        </MatchGroupHeader>
        <ul class="list-none divide-y divide-neutral-700/75">
          <li
            v-for="event in competition.events"
            :key="event.i"
            class="pre-event-item"
            :data-i="event.i"
          >
            <MatchListItem
              :event="event"
              :selections="preSelectionsMap[event.i] || []"
              :market="mainMarkets[sport]?.[0] || null"
            />
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
